import { useState as s, useEffect as r } from "react";
const f = () => {
  const [e, t] = s(!1);
  return r(() => {
    t(!0);
  }, []), e;
};
export {
  f as default
};
//# sourceMappingURL=useCSR.js.map
